<template>
  <!-- 用户管理- 用户关联-->
  <div class="benefit-statistical-box">
    <!-- header头部 -->
    <h3>用户关联</h3>
    <br />
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-left: 20px">
          <el-input
            v-model.trim="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间段:">
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box" v-if="dataList">
      <el-table
        :data="dataList"
        v-loading="loading"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column prop="user_id" label="用户ID" width="100px">
          <template slot-scope="{ row }">
            <span v-if="row.is_major == 1" style="color: red">{{
              row.user_id
            }}</span>
            <span v-else>{{ row.user_id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户名"></el-table-column>
        <el-table-column prop="status" label="用户状态">
          <template slot-scope="{ row }">
            <span v-if="row.status == 1">正常</span>
            <span v-else>冻结</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="recharge_amount"
          label="充值金额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="lottery_amount"
          label="抽奖金额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="prize_amount"
          label="奖品金额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="sold_amount"
          label="卖回金额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="account_balance"
          label="用户余额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="get_out_amount"
          label="取回金额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="wait_get_out_amount"
          label="待处理金额"
          sortable="custom"
        ></el-table-column>
        <!--					<el-table-column prop="get_out_fail_amount" label="取出失败金额" sortable="custom"></el-table-column>-->
        <el-table-column
          prop="backpack_amount"
          label="背包金额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="shop_balance"
          label="商城余额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="shop_amount"
          label="商城"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="exp_box_amount"
          label="升级余额"
          sortable="exp_box_amount"
        ></el-table-column>
        <el-table-column
          prop="anchor_amount"
          label="渠道金额"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="agent_amount"
          label="代理返利"
          sortable="custom"
        ></el-table-column>
        <el-table-column prop="welfare_staus" label="累充领完">
          <template slot-scope="{ row }">
            <span v-if="row.welfare_status">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="profit_amount" label="盈亏" sortable="custom">
        </el-table-column>
        <el-table-column
          prop="user_tag"
          label="备注"
        ></el-table-column>
        <!-- <el-table-column prop="total_num" label="总数据">
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>
<script>
import { server, delData, patchData, getData, postApiData, getApiData } from '@/http'
export default {
  data() {
    return {
      loading: false,
      query: {
        user_id: undefined,
        start_time: undefined,
        end_time: undefined
      },
      dataList: undefined,
    }
  },
  created() {

  },
  methods: {
    getData() {
      //获取数据
      if (!this.query.user_id) {
        this.$message.error("用户id必填")
        return
      }
      let params = this.query
      this.loading = true
      getApiData(`user_id_card`, params)
        .then(res => {
          this.dataList = res
        }).finally(() => {
          this.loading = false
        })
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总和';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              let num = (Number(prev) + Number(curr)).toFixed(2)
              return num;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else {
          sums[index] = ' ';
        }
      });

      return sums;
    },
  }
}
</script>
<style lang="less" scoped>
</style>